import type { Account } from '@travel-planner/shared/schemas';

export const formatAccountName = (
  account: Pick<Account, 'firstName' | 'lastName' | 'email'>
): string => {
  const first = account.firstName?.trim() ?? '';
  const last = account.lastName?.trim() ?? '';
  const full = [first, last].filter(Boolean).join(' ');
  return full || (account.email ?? '—');
};
